import { Component, OnInit, Input, EventEmitter, Output, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { PartnerService } from '../../partner-service';
import { Partner, PartnerUserDataGroup } from '../../models/partner';
import { PartnerUser, Privilege } from '../../models';
import { NgForm } from '@angular/forms';
import { Person } from '../../models/Person';
import { PartnerUserService } from '../../partner-user.service';
import { ConfirmationService } from 'primeng/api';
import { PersonService } from '../../../person/person.service';
import { PrivilegeService } from '../../privilege.service';

@Component({
  selector: 'app-edit-partner-user',
  templateUrl: './edit-partner-user.component.html',
  styleUrls: ['./edit-partner-user.component.scss'],
  providers: [ConfirmationService],
  encapsulation: ViewEncapsulation.None
})

export class EditPartnerUserComponent implements OnInit, OnDestroy {
  @Input() displayEditDialogInput: boolean;
  @Input() partnerDetails: PartnerUserDataGroup;
  @Input() relationshipData: Partner;

  @Output() onDialogOpen = new EventEmitter<boolean>();
  @Output() onDialogClose = new EventEmitter<boolean>();
  @Output() onUpdatePartnerUser = new EventEmitter<any>();
  @Output() onError = new EventEmitter<string>();

  partnerUser: PartnerUser;
  uniqueKey: string;
  canAddUser: string;
  relationshipId: number;
  subscription: Subscription;
  processing: boolean;
  assetGroupList: string;
  currentPartnerStatus: any;
  partnerStatus: any[];
  selectedItemsNow: any[] = [];
  userPrivileges: Privilege[] = [];
  partnershipPrivileges: Privilege[] = [];
  isPrimaryContactSelected = true;
  showResetPasswordLink: boolean=true;
  enableResetCancelButtons: boolean=false;
  emailStatus: boolean=false;
  loading: boolean;

  constructor(private partnerUserSvc: PartnerUserService
      , private confirmationService: ConfirmationService
      , private personSvc: PersonService
      , private partnerSvc: PartnerService
      , private partnershipPrivilegeSvc: PrivilegeService) { }

  ngOnInit() {
    this.partnerStatus = [
      {name: 'Active', value: true},
      {name: 'Inactive', value: false}
    ];
    this.currentPartnerStatus = this.partnerDetails.PartnerUser.Person.IsActive ?
                {name: 'Active', value: true} : {name: 'Inactive', value: false};
      let aData = [];
        for (let i = 0, group = this.partnerDetails.RelationshipDataGroup; i < group.length; i++) {
          if (group[i].IsMasterList) {
            aData = [];
            aData.push(group[i].RelationshipGroupName);
            break;
          } else {
            aData.push(group[i].Items.map((item) => item.ItemId).join(', '));
          }
        }
      this.assetGroupList = aData.join(', ');
    // retrieving unique partnership privileges based on groups privileges and privileges
    this.partnershipPrivileges = this.partnerSvc.getUniquePrivileges(this.relationshipData.PrivilegeGroups,
      this.relationshipData.Privileges);
    // getting enabled privileges for partnership
    this.partnershipPrivileges = this.partnershipPrivilegeSvc.findByStatus(this.partnershipPrivileges, true);
    // retrieving unique user privileges based on groups privileges and privileges
    this.userPrivileges = this.partnerSvc.getUniquePrivileges(this.partnerDetails.PartnerUser.PrivilegeGroups,
      this.partnerDetails.PartnerUser.Privileges);
    // getting enabled privileges for partner user
    this.userPrivileges = this.partnershipPrivilegeSvc.findByStatus(this.userPrivileges, true);
  }
  showResetCancelButtons(): void {
    this.enableResetCancelButtons = true;
    this.showResetPasswordLink = false;
  }

  hideResetCancelButtons() : void {
    this.enableResetCancelButtons =false;
    this.showResetPasswordLink=true;
  }

  emailResetPasswordLink() : void {
    this.emailStatus = false;
    this.enableResetCancelButtons =false;
    this.showResetPasswordLink=false;
    this.loading =true;
    this.personSvc.sendEmail(this.partnerDetails.PartnerUser.Person.PersonId,true)
    .subscribe((res: any) => {
        this.emailStatus=res.data[0].passwordEmailSent;
        this.loading =false;
      }, error => {
        this.loading =false;
        this.onError.emit('Error Occcured while Processing');
    });
  }

  showPasswordResetSection(user,partnerDetails) : boolean {
    // since isAtcive obtained from API , is being overwritten in the  func partnerStatusChange()
    // we need to refer the partnerDeatils structure in the same API to get the correct value of IsActive
    return user.Person.hasOwnProperty('IsPreReg') && !user.Person.IsPreReg && partnerDetails.PartnerUser.IsActive ? true : false;
  }

  dialogClose() {
    this.onDialogClose.emit(false);
  }

  dialogOpen() {
    this.onDialogOpen.emit(true);
  }

  // getting the latest selected items from privilege dropdown
  privilegeChange(privilege): void {
    this.selectedItemsNow = privilege.Privileges;
    this.partnerDetails.PartnerUser.Privileges = this.selectedItemsNow;
   }

  partnerStatusChange(): void {
    this.partnerDetails.PartnerUser.Person.IsActive = this.currentPartnerStatus.value;
    this.isPrimaryContactSelected =
      (this.partnerDetails.PartnerUser.IsPrimary && !this.partnerDetails.PartnerUser.Person.IsActive) ? false : true;
  }
  onSubmit(EditPartnerUserForm: NgForm): void {
    if (EditPartnerUserForm.valid) {
      this.processing = true;
      this.subscription = this.partnerUserSvc.update(this.relationshipData.RelationshipXrefId, this.partnerDetails)
        .subscribe((personData) => {
            this.onUpdatePartnerUser.emit(personData);
            this.processing = false;
            this.dialogClose();
          }, error => {
            this.onError.emit('Error Occcured while Processing');
            this.processing = false;
            this.dialogClose();
          });
    }
  }

  resendEmail() {
    this.confirmationService.confirm({
      message: 'Are you sure you want Reset/Resend Initial Email ?',
      reject: () => {
      },
      accept: () => {
        this.personSvc.sendEmail(this.partnerDetails.PartnerUser.Person.PersonId).subscribe();
        this.dialogClose();
      }
    });
  }

  /* New primary contact with RelationshipID */
  mapRelationshipAndContactId(relationshipAndContactId: any[]): void {
     this.partnerDetails.PartnerUser.NewPrimaryContactId = relationshipAndContactId[0].NewPrimaryContactId;
  }

  /* New Primary contact dropdown is valid or not */
  checkIsPrimaryContactReady(isPrimaryContactReady: boolean): void {
    this.isPrimaryContactSelected = typeof isPrimaryContactReady === 'undefined' ? true : isPrimaryContactReady;
  }

  ngOnDestroy() {
    if (this.subscription) { this.subscription.unsubscribe(); }
  }
}


